import React from 'react';
import LeakAdd from "@material-ui/icons/LeakAdd";
import Tooltip from "@material-ui/core/Tooltip";
interface IRadioCommunicationIconProps {
    show: boolean;
    color: string;
}

export const RadioCommunicationIcon = (props: IRadioCommunicationIconProps) => {
    const { show, color } = props;
    if (!show) {
        return null;
    }
    return (
        <Tooltip title="Radio Communication">
            <div style={{color: color}}>
                <LeakAdd />
            </div>
        </Tooltip>
    );
};

export default RadioCommunicationIcon;
